import type { FunctionComponent } from 'react';

import { Icon, registerIcon, VisuallyHiddenText } from '@pega/cosmos-react-core';
import type { ForwardProps, OmitStrict } from '@pega/cosmos-react-core';
import * as mailIcon from '@pega/cosmos-react-core/lib/components/Icon/icons/mail.icon';
import { NavigationListItem } from '@pega/cosmos-react-core/lib/components/AppShell/NavigationList';
import { StyledCountIcon } from '@pega/cosmos-react-core/lib/components/AppShell/AppShell.styles';

import type { EmailNotificationPanelProps } from './Email.types';

registerIcon(mailIcon);

export const EmailNotificationPanelIcon: FunctionComponent<
  OmitStrict<EmailNotificationPanelProps, 'onClick'> & ForwardProps
> = ({ label, count }) => {
  return (
    <>
      <Icon name='mail' />
      <VisuallyHiddenText>{label}</VisuallyHiddenText>
      <StyledCountIcon variant='urgent'>{count}</StyledCountIcon>
    </>
  );
};

const EmailNotificationPanel: FunctionComponent<EmailNotificationPanelProps & ForwardProps> = ({
  label,
  onClick,
  count,
  ...restProps
}) => {
  return (
    <NavigationListItem
      primary={label}
      visual={<EmailNotificationPanelIcon {...restProps} count={count} label={label} />}
      onClick={onClick}
    />
  );
};

export default EmailNotificationPanel;
